export default "__VITE_ASSET__z1L2M002__"